import { createSlice } from '@reduxjs/toolkit';
import { getLegacyPersonas } from '../legacy/thunk.js';

export const initialState = {
    legacyPersonas: [],
    loading: false,
    error: {},
};

const legacyPersonasSlice = createSlice({
    name: 'legacyPersonas',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyPersonas.fulfilled, (state, action) => {
            state.legacyPersonas = action.payload;
            state.loading = false;
        });
        builder.addCase(getLegacyPersonas.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = false;
        });
        builder.addCase(getLegacyPersonas.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyPersonasSlice.reducer;